/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.modal__close[_ngcontent-%COMP%]{margin-bottom:4px;align-self:flex-end;cursor:pointer}.modal__contents[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-flow:column;height:100vh}.modal__frame[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1 1 auto;display:-webkit-box;display:flex}"];
export { styles as styles };
